import { useRef } from 'react';

const useEnterKeySubmit = (onSubmit) => {
  const submittedEventRef = useRef(null);

  const onKeyPress = (e) => {
    if (e.key !== 'Enter') return;
    submittedEventRef.current = e.nativeEvent;
    onSubmit();
  };

  const onSubmitEditing = (e) => {
    if (e?.nativeEvent && submittedEventRef.current === e.nativeEvent) return;
    onSubmit();
  };

  return { onKeyPress, onSubmitEditing };
};

export default useEnterKeySubmit;
